import {
  ITextEyebrowChildSubtitle,
  ITextEyebrowChildTitle,
  TTextEyebrowChild,
} from "@/ui/components/typography/TextEyebrow/TextEyebrow.config";

export const isTextEyebrowChildTitle = (child: TTextEyebrowChild): child is ITextEyebrowChildTitle => {
  return child.component === "title";
};

export const isTextEyebrowChildSubtitle = (child: TTextEyebrowChild): child is ITextEyebrowChildSubtitle => {
  return child.component === "subtitle";
};
